export const ResetIcon = () => {
  return <span className="material-symbols-outlined">device_reset</span>;
};
